import React from 'react';
import {
  VStack,
  Heading,
  UnorderedList,
  ListItem,
  Text
} from '@chakra-ui/react';

export const Instructions: React.FC = () => {
  return (
    <VStack spacing={4} align="stretch">
      <Heading size="md">Instrucciones</Heading>
      <UnorderedList spacing={2}>
        <ListItem>
          <Text>Captura el marcador que creas para cada partido.</Text>
        </ListItem>
        <ListItem>
          <Text>Los puntos se asignan de la siguiente manera:</Text>
          <UnorderedList ml={4} mt={2}>
            <ListItem>Resultado exacto: 3 puntos</ListItem>
            <ListItem>Resultado parcial (ganador/empate): 1 punto</ListItem>
            <ListItem>
              <Text>
                <b>Puntos extra por etapa eliminatoria:</b> En las etapas de <b>Cuartos de Final, Semifinal y Final</b>, si aciertas la suma total de goles anotados en ambos partidos (ida y vuelta) de una misma etapa, obtienes <b>2 puntos extra</b>.
              </Text>
            </ListItem>
            <ListItem>
              <Text>
                <b>Ejemplo:</b> Si en los partidos de ida y vuelta de Cuartos de Final se anotaron en total 7 goles, y tú pronosticaste exactamente 7 goles sumando tus predicciones de ambos partidos, ¡ganas 2 puntos extra!
              </Text>
            </ListItem>
          </UnorderedList>
        </ListItem>
        <ListItem>
          <Text>Una vez guardada tu quiniela, no podrás modificarla.</Text>
        </ListItem>
        <ListItem>
          <Text>Los resultados se actualizarán conforme terminen los partidos.</Text>
        </ListItem>
      </UnorderedList>
    </VStack>
  );
}; 